export class HttpRequestVerbs {
    static readonly GET = 'GET';
    static readonly POST = 'POST';
    static readonly PUT = 'PUT';
    static readonly DELETE = 'DELETE';
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/http-request-verbs.ts